export default {
    message: {
        bold: 'bold',
        italic: 'italic',
        strike: 'strike',
        underline: 'underline',
        code: 'code',
        code_block: 'code block',
        paragraph: 'paragraph',
        h1: 'heading 1',
        h2: 'heading 2',
        h3: 'heading 3',
        bullet_list: 'bullet list',
        ordered_list: 'ordered list',
        horizontal_rule: 'horizontal rule',
        link: 'insert link',
        blockquote: 'blockquote',
        redo: 'redo',
        undo: 'undo',
        image: 'insert image',
        imageLeftFloat: 'image left float',
        imageRightFloat: 'image right float',
        imageEraser: 'image eraser',
        confirm: 'confirm',
    },
};
